import styled from 'styled-components';

export const UsersWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 64px);
  background: ${({ theme }) => theme.landing.background};
  transition: background 0.3s ease;
  overflow-x: hidden;
`;

export const UsersContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  margin-top: 64px;
  padding: ${({ theme }) => theme.landingSpacing.xl};
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    padding: ${({ theme }) => theme.landingSpacing.lg};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: ${({ theme }) => theme.landingSpacing.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.sm};
  }
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.landingSpacing.md};
  margin-bottom: ${({ theme }) => theme.landingSpacing.lg};
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    align-items: stretch;
    gap: ${({ theme }) => theme.landingSpacing.sm};
  }
`;

export const HeaderLeft = styled.div`
  min-width: 0;
`;

export const Title = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 1.75rem;
  letter-spacing: -0.02em;
  margin: 0;
  color: ${({ theme }) => theme.landing.text};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 1.4rem;
  }
`;

export const Description = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  color: ${({ theme }) => theme.landing.textSecondary};
  margin: 6px 0 0;
  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    display: none;
  }
`;

export const HeaderActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  flex-shrink: 0;
`;

export const AddUserButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 ${({ theme }) => theme.landingSpacing.md};
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  background: ${({ theme }) => theme.landing.buttonBg};
  color: #fff;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.15s ease,
    transform 0.1s ease;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  &:hover {
    background: ${({ theme }) => theme.landing.buttonHover};
  }

  &:active {
    transform: scale(0.98);
  }
`;

/* ------------------------------------------------------------------ */
/* Table card + toolbar                                                */
/* ------------------------------------------------------------------ */

export const TableCard = styled.section`
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden; /* clips the toolbar/rows to the card's rounded corners */
  max-width: 100%;
`;

export const TableToolbar = styled.div`
  padding: ${({ theme }) => theme.landingSpacing.md};
  border-bottom: 1px solid ${({ theme }) => theme.landing.cardBorder};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.landingSpacing.sm};
  }
`;

export const SearchSlot = styled.div`
  max-width: 360px;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    max-width: 100%;
  }
`;

/* ------------------------------------------------------------------ */
/* Table cell content — unchanged, columns are not removed anywhere    */
/* ------------------------------------------------------------------ */

export const UserNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UserName = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  color: ${({ theme }) => theme.landing.text};
`;

export const EmailText = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 13px;
  color: ${({ theme }) => theme.landing.textSecondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const JoinedText = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 13px;
  color: ${({ theme }) => theme.landing.textSecondary};
  white-space: nowrap;
`;

export const RowActionsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const RowActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.sm};
  background: transparent;
  color: ${({ theme }) => theme.landing.textSecondary};
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  svg {
    width: 15px;
    height: 15px;
  }

  &:hover:not(:disabled) {
    background: ${({ $danger, theme }) =>
      $danger ? 'rgba(239, 68, 68, 0.1)' : theme.landing.iconBg};
    color: ${({ $danger, theme }) => ($danger ? theme.landing.errorColor : theme.landing.text)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg[data-spin='true'] {
    animation: spin 1s linear infinite;
  }
`;
